import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import bgImg from '@/assets/image2/c27f84d613a3bd5cc4f1495e710fea5.jpg';
import { LeftOutlined } from '@ant-design/icons';
const Detail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const normalParam = searchParams.get('normal') || '1';
    const containerRef = useRef(null);
    const [containerHeight, setContainerHeight] = useState('50vw');
    const [aspectRatio, setAspectRatio] = useState(3/4);
    const [isAnimating, setIsAnimating] = useState(false);

    const imgStyle = {
        display: 'block',
        margin: 0,
        width: '100%',
        loading: 'lazy'
    };

    let imgList = [
        { value: 1 }, { value: 2 }, { value: 3 }, { value: 4 },
        { value: 5 }, { value: 6 }, { value: 7 }, { value: 8 },
    ];

    useEffect(() => {
        const img = new Image();
        img.src = require('@/assets/image2/k/1.jpg');
        img.onload = () => {
            setAspectRatio(img.height / img.width);
        };
    }, []);

    useEffect(() => {
        const updateHeight = () => {
            if (containerRef.current) {
                const containerWidth = containerRef.current.offsetWidth;
                const activeWidth = containerWidth * 0.419;
                const height = activeWidth * aspectRatio;
                setContainerHeight(`${height}px`);
            }
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, [aspectRatio]);

    const handleHome = () => {
        navigate('/');
        setTimeout(() => {
            const element = document.getElementById('engagement');
            if (element) {
                element.scrollIntoView({ behavior: 'auto' });
            }
        }, 100);
    };

    const handleImageClick = (itemValue) => {
        if (itemValue === normalParam || isAnimating) return;

        setIsAnimating(true);
        navigate(`/detail?normal=${itemValue}`);

        setTimeout(() => {
            setIsAnimating(false);
        }, 500);
    };

    return (
        <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: '#fff'
        }}>
            {/* Header Section */}
            <div style={{ position: "relative" }}>
                <div  style={{
                    fontSize:'1vw',
                    cursor: "pointer",
                    position: "absolute",
                    top: '3vw',
                    color:'white',
                    left: '5vw'
                }}
                      onClick={handleHome}
                >
                    <LeftOutlined style={{marginRight:'.4vw'}}/> 返回 丨 Back
                </div>
                <img
                    src={require('@/assets/image2/二级页面1.jpg')}
                    alt=""
                    style={imgStyle}
                    loading="lazy"
                />
                <img
                    alt=''
                    src={require('@/assets/image/menu/LOGO.png')}
                    onClick={handleHome}
                    style={{
                        width: '17vw',
                        cursor: "pointer",
                        position: "absolute",
                        top: '2.3vw',
                        right: '5vw'
                    }}
                    loading="lazy"
                />
            </div>

            {/* Image Gallery Section */}
            <div
                ref={containerRef}
                style={{
                    display: 'flex',
                    height: containerHeight,
                    transition: 'all 0.5s ease',
                }}
            >
                {imgList.map((item) => (
                    <div
                        key={`container-${item.value}`}
                        style={{
                            width: item.value === Number(normalParam) ? '41.9%' : 'calc(58.5%/7)',
                            transition: 'all 0.5s ease',
                            overflow: 'hidden',
                            position: 'relative',
                            height: '100%',
                        }}
                    >
                        <div style={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                            paddingTop: `${aspectRatio * 100}%`,
                        }}>
                            <img
                                src={require(`@/assets/image2/${item.value === Number(normalParam) ? 'k' : 'c'}/${item.value}.jpg`)}
                                alt=""
                                onClick={() => handleImageClick(item.value)}
                                style={{
                                    cursor: isAnimating ? 'default' : 'pointer',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    display: 'block',
                                    transition: 'all 0.5s ease',
                                }}
                                loading={item.value === Number(normalParam) ? 'eager' : 'lazy'}
                            />
                        </div>
                    </div>
                ))}
            </div>

            {/* Background Image Section */}
            <div style={{
                flex: 1,
                minHeight: 0,
                overflow: 'hidden',
                position: 'relative',
                backgroundColor: '#f0f0f0'
            }}>
                <img
                    alt='background'
                    src={bgImg}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center'
                    }}
                    loading="lazy"
                />
            </div>
        </div>
    );
};

export default Detail;
